import React from "react";
import SEO from "../components/SEO";
import { Toaster } from "react-hot-toast";
import TopBar from "../components/global-components/topbar";
import FooterV1 from "../components/global-components/footer";
import MainNavbar from "../components/MainNavbar";
import CallToActonV1 from "../components/section-components/call-to-action-v1";
import TermsAcceptanceGate from "../components/TermsAcceptanceGate";

const ComponentProvider = ({
  children,
  isLogged,
  isOffline,
  userUid,
  isCheckingAuth,
}) => {
  return (
    <>
      <SEO />
      {isOffline && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: "#ff6b6b",
            color: "white",
            padding: "10px",
            textAlign: "center",
            zIndex: 9999,
          }}
        >
          Você está offline. Algumas funcionalidades podem não estar disponíveis.
        </div>
      )}
      <TopBar />
      <MainNavbar />
      <TermsAcceptanceGate
        isLoggedIn={isLogged}
        userId={userUid}
        isCheckingAuth={isCheckingAuth}
      />
      {children}
      {!isLogged && <CallToActonV1 />}
      <FooterV1 />
      <Toaster position="bottom-center" />
    </>
  );
};

export default ComponentProvider;

